export interface MobileAuthResponse {
  accessToken: string;
  refreshToken: string;
  accessExpiresAt?: string;
  refreshExpiresAt?: string;
  /** Cuentas con 2FA activo: la app móvil aún no soporta el segundo paso, así que no se abre sesión. */
  mfaRequired?: boolean;
}

export interface MobileLoginRequest {
  email: string;
  password: string;
}

export interface MobileRefreshRequest {
  refreshToken: string;
}

export const MOBILE_ACCESS_TOKEN_KEY = 'prosell_mobile_access_token';
export const MOBILE_REFRESH_TOKEN_KEY = 'prosell_mobile_refresh_token';
export const MOBILE_DEVICE_ID_KEY = 'prosell_mobile_device_id';
